import React, { useState, useEffect } from "react";
import { useSearchParams, useLocation } from "react-router-dom";
import Footer from "../../components/footer/footer";
import Slidebar from "../../components/slidebar";
import Products from "../../components/Product";
import ProductSkeleton from "../../components/Product/ProductSkeleton";
import { fetchDataFromApi } from "../../utils/api";
import { Link } from "react-router-dom";
import "./index.css";

const Listing = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();
  
  // Get category from URL parameters
  const categoryFromUrl = searchParams.get('category');
  const categoryNameFromUrl = searchParams.get('name');
  
  // States
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [products, setProducts] = useState([]);
  const [priceRange, setPriceRange] = useState([0, 1000]);
  const [ratingFilter, setRatingFilter] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  // Set selected category when URL changes or component mounts
  useEffect(() => {
    if (categoryFromUrl && categoryFromUrl !== 'all') {
      setSelectedCategory(categoryFromUrl);
    } else {
      setSelectedCategory('all');
    }
  }, [categoryFromUrl, location.search]);

  const fetchProducts = async () => {
    setIsLoading(true);
    try {
      let url = `/api/products`;
      if (selectedCategory !== "all") {
        url = `/api/products?catId=${selectedCategory}`;
      }
      
      const res = await fetchDataFromApi(url);
      let filtered = res?.products || [];

      // Apply price filter
      filtered = filtered.filter(
        (p) => p.price >= priceRange[0] && p.price <= priceRange[1]
      );

      // Apply rating filter - EXACT MATCH ONLY
      if (ratingFilter && ratingFilter !== "") {
        filtered = filtered.filter((p) => {
          const productRating = parseFloat(p.rating || 0);
          const filterRating = parseFloat(ratingFilter);
          
          // Round both ratings to 1 decimal place for exact comparison
          const roundedProductRating = Math.round(productRating * 10) / 10;
          const roundedFilterRating = Math.round(filterRating * 10) / 10;
          
          // For exact star matching, check if product rating falls within the star range
          // For example: 3 star filter should match products with rating 3.0 to 3.9
          return Math.floor(productRating) === filterRating;
        });
      }

      setProducts(filtered);
      console.log(`Filtered products for ${ratingFilter} star(s):`, filtered.length);
    } catch (err) {
      console.error("Error fetching products:", err);
      setProducts([]);
    } finally {
      setIsLoading(false);
    }
  };

  // Initial load
  useEffect(() => {
    fetchProducts();
  }, []);

  // Fetch products when filters change
  useEffect(() => {
    fetchProducts();
  }, [selectedCategory, priceRange, ratingFilter]);

  // Handle category change from sidebar
  const handleCategoryChange = (categoryId) => {
    setSelectedCategory(categoryId);
    
    // Update URL parameters
    const newSearchParams = new URLSearchParams(searchParams);
    if (categoryId && categoryId !== 'all') {
      newSearchParams.set('category', categoryId);
    } else {
      newSearchParams.delete('category');
      newSearchParams.delete('name');
    }
    
    // Update URL without page reload
    setSearchParams(newSearchParams);
  };

  return (
    <>
      <section className="listingPage">
        <div className="container-fluid">
          <div className="listingData">
            <div className="d-flex flex-row">
              <div
                className="slidebarWrapper"
                style={{ minWidth: "260px", maxWidth: "300px" }}
              >
                <Slidebar
                  selectedCategory={selectedCategory}
                  setSelectedCategory={handleCategoryChange}
                  priceRange={priceRange}
                  setPriceRange={setPriceRange}
                  ratingFilter={ratingFilter}
                  setRatingFilter={setRatingFilter}
                  onApplyFilters={fetchProducts}
                />
              </div>

              <div
                className="rightContent homeProducts"
                style={{ flexGrow: 1 }}
              >
                {/* Only Products Grid - No headers or messages */}
                <div className="productRow">
                  {isLoading ? (
                    <>
                      {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((i) => (
                        <div key={i} className="item">
                          <ProductSkeleton />
                        </div>
                      ))}
                    </>
                  ) : products.length > 0 ? (
                    products.map((item, index) => (
                      <div className="item fade-in" key={item._id || index}>
                        <Products item={item} />
                      </div>
                    ))
                  ) : (
                    <div className="item" style={{ gridColumn: "1 / -1" }}>
                      <div className="text-center mt-5 p-5">
                        <h4 className="text-muted">
                          {ratingFilter ? 
                            `No products found for ${ratingFilter} star${ratingFilter > 1 ? 's' : ''}` : 
                            'No products found'
                          }
                        </h4>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Listing;